<template>
  <main class="container solution-scent">
    <section ref="sectionRef" class="wellcome-section">
      <button class="btn outline">Fragrance Solution Airperfume</button>
      <h1>
        Transforming Spaces into
        <br class="pc_show" />
        Memorable, Desirable Locations
      </h1>
      <p>Our professional consultants customize fragrance solutions to suit the specific concepts of industries and spaces.</p>

      <router-link to="/contact/mail/send?local=eng">
        <p ref="buttonRef" id="applyButton" :class="[buttonClass, buttonHiddenClass]">Send Email</p>
      </router-link>
    </section>

    <img
      :src="require(`@/assets/images/solution/scent/main${mobileCheck ? '_mo' : ''}.png`)"
      class="main-img"
      alt="CESCO [Solution] Fragrance Solution Airperfume"
    />

    <section class="section scent-effects">
      <div class="contents-center">
        <div class="card-type-m">
          <div class="card">
            <div>
              <h4>Scent Effects Validated by Research</h4>
              <p>Memories formed by scent are said to be over 100 times more vivid than those made through sight, hearing, or touch.</p>
            </div>
            <div>
              <div class="scent-effects-card">
                <h3 class="percent-number">15<span>%</span></h3>
                <div class="content">
                  <p class="text">
                    Purchase
                    <br />
                    Desire
                  </p>
                </div>
              </div>
              <div class="scent-effects-card">
                <h3 class="percent-number">26<span>%</span></h3>
                <div class="content">
                  <p class="text">
                    Perceived as <br />
                    shorter than <br />
                    actual time
                  </p>
                </div>
              </div>
              <div class="scent-effects-card">
                <h3 class="percent-number">40<span>%</span></h3>
                <div class="content">
                  <p class="text">
                    Mood <br />
                    Enhancement
                  </p>
                </div>
              </div>
              <div class="scent-effects-card">
                <h3 class="percent-number">45<span>%</span></h3>
                <div class="content">
                  <p class="text">
                    Increases <br />
                    Duration of <br />
                    Stay
                  </p>
                </div>
              </div>
              <div class="scent-effects-card">
                <h3 class="percent-number">54<span>%</span></h3>
                <div class="content">
                  <p class="text">
                    Reduces Clerical <br />
                    Errors
                  </p>
                </div>
              </div>
              <div class="scent-effects-card">
                <h3 class="percent-number">60<span>%</span></h3>
                <div class="content">
                  <p class="text">
                    Enhances Memory Retention <br />
                    via Scent
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div>
              <h4>Scent Effects Customized to Customer Traffic</h4>
              <p>Scents attract customers, send positive messages about the brand, and encourage revisits and consumption.</p>
            </div>
            <div>
              <div class="customer-traffic-card">
                <img src="@/assets/images/solution/scent/traffic_01.svg" />
                <p class="text">
                  Customers satisfied with the emotional service are inclined to stay longer and feel a heightened desire to purchase.
                </p>
              </div>
              <div class="customer-traffic-card">
                <img src="@/assets/images/solution/scent/traffic_02.svg" />
                <p class="text">The initial scent encounter induces a positive psychological state.</p>
              </div>
              <div class="customer-traffic-card">
                <img src="@/assets/images/solution/scent/traffic_03.svg" />
                <p class="text">Scents in resting/waiting areas help alleviate tension and provide comfort.</p>
              </div>
              <div class="customer-traffic-card">
                <img src="@/assets/images/solution/scent/traffic_04.svg" />
                <p class="text">Conveys a positive message about the brand and store, boosting the likelihood of return visits.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section tab-area">
      <div class="contents-center">
        <div class="tab-info">
          <h3 class="title-section">Airperfume Advantages</h3>

          <p class="description-section">
            CESCO Airperfume provides a scent consulting solution tailored to specific industry and
            <br />
            space requirements.
          </p>
        </div>

        <div class="tabs">
          <button
            v-for="item in tabList"
            :key="`tab-${item.id}`"
            :id="`tab-${item.id}`"
            :class="['tab-button', tab === item.id && 'active']"
            @click="handleTabClick(item.id)"
          >
            {{ item.name }}
          </button>
        </div>

        <button class="btn-list">Press the button to check.</button>
      </div>

      <div v-if="!mobileCheck" class="tab-contents">
        <div v-if="tab === 0" class="tab-content">
          <swiper :slides-per-view="'auto'" :centered-slides="true" class="airperfume-swiper">
            <swiper-slide>
              <h4>
                Airperfume enhances the experience beyond just scents,
                <br />
                considering visitors as well.
              </h4>

              <img src="@/assets/images/solution/scent/tab01_01.svg" alt="CESCO [Solution] Fragrance Solution Airperfume" />
            </swiper-slide>
            <swiper-slide>
              <h4>
                Scent <br />
                Specialization
              </h4>

              <img src="@/assets/images/solution/scent/tab01_02.svg" alt="CESCO [Solution] Fragrance Solution Airperfume" />
            </swiper-slide>
          </swiper>
        </div>

        <div v-if="tab === 1" class="tab-content">
          <swiper :slides-per-view="'auto'" :centered-slides="true" class="airperfume-swiper">
            <swiper-slide>
              <h4>
                CESCO’s patented and applied
                <br />
                micro-particle spraying module
              </h4>

              <img src="@/assets/images/solution/scent/tab02_01.svg" alt="CESCO [Solution] Fragrance Solution Airperfume" />
            </swiper-slide>
            <swiper-slide>
              <h4>
                Optimized management tailored to each customer using
                <br />
                smart technology
              </h4>

              <img src="@/assets/images/solution/scent/tab02_02.svg" alt="CESCO [Solution] Fragrance Solution Airperfume" />
            </swiper-slide>
            <swiper-slide>
              <h4>
                A soundproof and dustproof enclosed structure design minimizes noise
                <br />
                and vibration
              </h4>

              <img src="@/assets/images/solution/scent/tab02_03.svg" alt="CESCO [Solution] Fragrance Solution Airperfume" />
            </swiper-slide>
          </swiper>
        </div>

        <div v-if="tab === 2" class="tab-content">
          <swiper :slides-per-view="'auto'" :centered-slides="true" class="airperfume-swiper">
            <swiper-slide>
              <h4>
                Nationwide infrastructure for consulting and management for
                <br />
                small-scale businesses in regional areas
              </h4>

              <img src="@/assets/images/solution/scent/tab03_01.svg" alt="CESCO [Solution] Fragrance Solution Airperfume" />
            </swiper-slide>
            <swiper-slide>
              <h4>
                Custom scent proposals and
                <br />
                one-stop equipment operation
              </h4>

              <img src="@/assets/images/solution/scent/tab03_02.svg" alt="CESCO [Solution] Fragrance Solution Airperfume" />
            </swiper-slide>
            <swiper-slide>
              <h4>
                50 years of expertise in business
                <br />
                environment hygiene management
              </h4>

              <img src="@/assets/images/solution/scent/tab03_03.svg" alt="CESCO [Solution] Fragrance Solution Airperfume" />
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </section>

    <section class="section scent-note">
      <div class="contents-center">
        <h3 class="title-section">Airperfume Scent Note Collection</h3>
        <p class="description-section">
          Enhance your business space with optimal scents crafted by professional perfumers,
          <br />
          using high-quality fragrances designed to suit each concept, exclusive to CESCO.
        </p>

        <div class="card-type-m">
          <div class="card">
            <div class="icon">
              <img src="@/assets/images/solution/scent/note01_01.png" />
            </div>
            <div class="content">
              <div>
                <h4 class="title">Herb Notes</h4>
                <p class="description">Filled with the aromatic and refreshing essence of herb plants, reminiscent of being in a lush forest.</p>
              </div>
              <div class="tag-content">
                <img src="@/assets/images/solution/scent/note01_02.png" alt="CESCO [Solution] Fragrance Solution Airperfume" />
                <div class="tags" style="color: #6e803b">
                  <span class="tag"> #Healing </span>
                  <span class="tag"> #TensionRelief </span>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="icon">
              <img src="@/assets/images/solution/scent/note02_01.png" />
            </div>
            <div class="content">
              <div>
                <h4 class="title">Aqua Notes</h4>
                <p class="description">
                  Creates a moist, water-like feeling paired with
                  <br />
                  a refreshing atmosphere.
                </p>
              </div>
              <div class="tag-content">
                <img src="@/assets/images/solution/scent/note02_02.png" alt="CESCO [Solution] Fragrance Solution Airperfume" />
                <div class="tags" style="color: #0094ff">
                  <span class="tag"> #Comfort </span>
                  <span class="tag"> #ActivityStimulation </span>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="icon">
              <img src="@/assets/images/solution/scent/note03_01.png" />
            </div>
            <div class="content">
              <div>
                <h4 class="title">Floral Notes</h4>
                <p class="description">Rich yet elegant flowers generate a lovely ambiance.</p>
              </div>
              <div class="tag-content">
                <img src="@/assets/images/solution/scent/note03_02.png" alt="CESCO [Solution] Fragrance Solution Airperfume" />
                <div class="tags" style="color: #9d87bd">
                  <span class="tag"> #EntryInduction </span>
                  <span class="tag"> #PurchaseStimulation </span>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="icon">
              <img src="@/assets/images/solution/scent/note04_01.png" />
            </div>
            <div class="content">
              <div>
                <h4 class="title">Fruity Notes</h4>
                <p class="description">Evokes the freshness and sweetness of fruits, excluding citrus.</p>
              </div>
              <div class="tag-content">
                <img src="@/assets/images/solution/scent/note04_02.png" alt="CESCO [Solution] Fragrance Solution Airperfume" />
                <div class="tags" style="color: #d66465">
                  <span class="tag"> #ActivityStimulation </span>
                  <span class="tag"> #OdorRemoval </span>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="icon">
              <img src="@/assets/images/solution/scent/note05_01.png" />
            </div>
            <div class="content">
              <div>
                <h4 class="title">Citrus Notes</h4>
                <p class="description">Captures the essence of fresh and crisp citrus fruits.</p>
              </div>
              <div class="tag-content">
                <img src="@/assets/images/solution/scent/note05_02.png" alt="CESCO [Solution] Fragrance Solution Airperfume" />
                <div class="tags" style="color: #a88124">
                  <span class="tag"> #TasteStimulation </span>
                  <span class="tag"> #OdorRemoval </span>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="icon">
              <img src="@/assets/images/solution/scent/note06_01.png" />
            </div>
            <div class="content">
              <div>
                <h4 class="title">Wood Notes</h4>
                <p class="description">
                  Conjures a luxurious image through scents of wood, including bark and aromatic wood, evoking the comfort of nature.
                </p>
              </div>
              <div class="tag-content">
                <img src="@/assets/images/solution/scent/note06_02.png" alt="CESCO [Solution] Fragrance Solution Airperfume" />
                <div class="tags" style="color: #7c5d46">
                  <span class="tag"> #Healing </span>
                  <span class="tag"> #TensionRelief </span>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="icon">
              <img src="@/assets/images/solution/scent/note07_01.png" />
            </div>
            <div class="content">
              <div>
                <h4 class="title">Musk Notes</h4>
                <p class="description">Supports lasting fragrance, conveying a soft sensation.</p>
              </div>
              <div class="tag-content">
                <img src="@/assets/images/solution/scent/note07_02.png" alt="CESCO [Solution] Fragrance Solution Airperfume" />
                <div class="tags" style="color: #424c53">
                  <span class="tag"> #Healing </span>
                  <span class="tag"> #TensionRelief </span>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="icon">
              <img src="@/assets/images/solution/scent/note08_01.png" />
            </div>
            <div class="content">
              <div>
                <h4 class="title">Food Notes</h4>
                <p class="description">Transforms olfactory stimulation into gustatory pleasure, creating a delightful, sweet atmosphere.</p>
              </div>
              <div class="tag-content">
                <img src="@/assets/images/solution/scent/note08_02.png" alt="CESCO [Solution] Fragrance Solution Airperfume" />
                <div class="tags" style="color: #6a413d">
                  <span class="tag"> #Direction </span>
                  <span class="tag"> #TasteStimulation </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="basic-mo-swiper">
      <div>
        <h3 class="title-section">Type-Based Recommendations</h3>
        <p class="description-section">We offer scent consultation services tailored industry spaces and types.</p>
      </div>

      <swiper
        :slides-per-view="'auto'"
        :loop="true"
        :autoplay="{
          delay: 2000,
          disableOnInteraction: false
        }"
        :modules="[Autoplay]"
        class="type-swiper"
      >
        <swiper-slide class="product-card">
          <div class="header">
            <img class="product-image" src="@/assets/images/solution/scent/type01_01.png" alt="CESCO [Solution] Fragrance Solution Airperfume" />
            <h3 class="product-name">Lobby</h3>
            <p class="note">
              Provides healing with
              <br />
              a luxurious scent.
            </p>
          </div>
          <div class="content">
            <img src="@/assets/images/solution/scent/type01_02.png" />
            <p>
              <span> Recommended Notes </span>
              <br />
              Wood / Floral
            </p>
          </div>
        </swiper-slide>
        <swiper-slide class="product-card">
          <div class="header">
            <img class="product-image" src="@/assets/images/solution/scent/type02_01.png" alt="CESCO [Solution] Fragrance Solution Airperfume" />
            <h3 class="product-name">Fitness</h3>
            <p class="note">Neutralizes unpleasant sweat odors and creates a pleasant atmosphere.</p>
          </div>
          <div class="content">
            <img src="@/assets/images/solution/scent/type02_02.png" />
            <p>
              <span> Recommended Notes </span>
              <br />
              Citrus / Fruity
            </p>
          </div>
        </swiper-slide>
        <swiper-slide class="product-card">
          <div class="header">
            <img class="product-image" src="@/assets/images/solution/scent/type03_01.png" alt="CESCO [Solution] Fragrance Solution Airperfume" />
            <h3 class="product-name">Exhibition</h3>
            <p class="note">Delivers a calming atmosphere with a comforting scent.</p>
          </div>
          <div class="content">
            <img src="@/assets/images/solution/scent/type03_02.png" />
            <p>
              <span> Recommended Notes </span>
              <br />
              Musk / Wood
            </p>
          </div>
        </swiper-slide>
        <swiper-slide class="product-card">
          <div class="header">
            <img class="product-image" src="@/assets/images/solution/scent/type04_01.png" alt="CESCO [Solution] Fragrance Solution Airperfume" />
            <h3 class="product-name">Cafe</h3>
            <p class="note">Delivers a relaxing break with stress-relieving scents.</p>
          </div>
          <div class="content">
            <img src="@/assets/images/solution/scent/type04_02.png" />
            <p>
              <span> Recommended Notes </span>
              <br />
              Food / Fruity
            </p>
          </div>
        </swiper-slide>
        <swiper-slide class="product-card">
          <div class="header">
            <img class="product-image" src="@/assets/images/solution/scent/type05_01.png" alt="CESCO [Solution] Fragrance Solution Airperfume" />
            <h3 class="product-name">Hospital</h3>
            <p class="note">Neutralizes medicinal odors and reduces stress.</p>
          </div>
          <div class="content">
            <img src="@/assets/images/solution/scent/type05_02.png" />
            <p>
              <span> Recommended Notes </span>
              <br />

              Herb / Musk
            </p>
          </div>
        </swiper-slide>
        <swiper-slide class="product-card">
          <div class="header">
            <img class="product-image" src="@/assets/images/solution/scent/type06_01.png" alt="CESCO [Solution] Fragrance Solution Airperfume" />
            <h3 class="product-name">Office</h3>
            <p class="note">Calming scent enhances focus and relieves tension.</p>
          </div>
          <div class="content">
            <img src="@/assets/images/solution/scent/type06_02.png" />
            <p>
              <span> Recommended Notes </span>
              <br />
              Floral / Herb
            </p>
          </div>
        </swiper-slide>
        <swiper-slide class="product-card">
          <div class="header">
            <img class="product-image" src="@/assets/images/solution/scent/type07_01.png" alt="CESCO [Solution] Fragrance Solution Airperfume" />
            <h3 class="product-name">Entertainment</h3>
            <p class="note">Neutralizes odors and encourages revisits.</p>
          </div>
          <div class="content">
            <img src="@/assets/images/solution/scent/type07_02.png" />
            <p>
              <span> Recommended Notes </span>
              <br />
              Citrus / Food
            </p>
          </div>
        </swiper-slide>
        <swiper-slide class="product-card">
          <div class="header">
            <img class="product-image" src="@/assets/images/solution/scent/type08_01.png" alt="CESCO [Solution] Fragrance Solution Airperfume" />
            <h3 class="product-name">Kids</h3>
            <p class="note">Recommends scents that are free of allergens designated by Korea Ministry of Environment.</p>
          </div>
          <div class="content">
            <img src="@/assets/images/solution/scent/type08_02.png" />
            <p>
              <span> Recommended Notes </span>
              <br />
              Freesia / White Tea
            </p>
          </div>
        </swiper-slide>
        <swiper-slide class="product-card">
          <div class="header">
            <img class="product-image" src="@/assets/images/solution/scent/type09_01.png" alt="CESCO [Solution] Fragrance Solution Airperfume" />
            <h3 class="product-name">Shopping</h3>
            <p class="note">Calming scent enhances shopping time and stimulates purchases.</p>
          </div>
          <div class="content">
            <img src="@/assets/images/solution/scent/type09_02.png" />
            <p>
              <span> Recommended Notes </span>
              <br />
              Floral / Aqua
            </p>
          </div>
        </swiper-slide>
      </swiper>
    </section>

    <section ref="checkSectionRef" class="sub-footer">
      <h2>
        Our professional consultant will visit you <br class="pc_show" />
        to provide scent consultations.
      </h2>
      <p>
        Experience the scents firsthand and choose the fragrance that
        <br />
        best suits your venue.
      </p>

      <router-link to="/contact/mail/send?local=eng" class="btn"> Send Email </router-link>
    </section>
  </main>

  <ModalView v-if="mobileCheck" :modal-state="modalState" @close-modal="closeModal">
    <ScentModalContent :tab="tab" :text="tabList[tab].name" />
  </ModalView>
</template>

<script setup>
import { inject } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay } from 'swiper/modules'
import { useMeta } from 'vue-meta'
import { useScroll, useModal, useTab } from '@/hooks'
import ModalView from '@/components/common/ModalView.vue'
import ScentModalContent from '@/components/modal/ScentModalContent.vue'

const { sectionRef, checkSectionRef, buttonRef, buttonClass, buttonHiddenClass } = useScroll()
const { modalState, openModal, closeModal } = useModal()
const { tab, handleTabClick } = useTab(openModal)

const mobileCheck = inject('mobileCheck')

const tabList = [
  { id: 0, name: 'Scent Safety' },
  { id: 1, name: 'Unique Technological Expertise' },
  { id: 2, name: 'Post-Service Care' }
]

useMeta({
  title: 'CESCO - Fragrance Solution Airperfume',
  meta: [
    {
      vmid: 'description',
      name: 'description',
      content: 'Transforming Spaces into Memorable, Desirable Locations'
    }
  ]
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/scent.scss';
</style>
